const finance = [
  {
    id: 1,
    type: 'دفعة مدرسية',
    targetName: 'أحمد الزعبي',
    amount: 1200,
    paymentDate: '2024-04-10',
    status: 'مدفوع',
    method: 'نقدي',
    category: 'وارد',
  },
  {
    id: 2,
    type: 'دفعة نقل',
    targetName: 'سارة الخطيب',
    amount: 300,
    paymentDate: '2024-04-05',
    status: 'مدفوع',
    method: 'تحويل بنكي',
    category: 'وارد',
  },
  {
    id: 3,
    type: 'رسم نشاطات',
    targetName: 'محمد الدسوقي',
    amount: 150,
    paymentDate: '2024-03-15',
    status: 'لم يتم الدفع',
    method: 'نقدي',
    category: 'وارد',
  },
  {
    id: 4,
    type: 'راتب موظف',
    targetName: 'رامي عبدالله',
    amount: 1500,
    paymentDate: '2024-04-01',
    status: 'مدفوع',
    method: 'تحويل بنكي',
    category: 'صادر',
  },
  {
    id: 5,
    type: 'مصروفات صيانة',
    targetName: 'شركة صيانة الحافلات',
    amount: 700,
    paymentDate: '2024-03-20',
    status: 'مدفوع',
    method: 'شيك',
    category: 'صادر',
  },
  {
    id: 6,
    type: 'دفعة مدرسية',
    targetName: 'سامي عبيدات',
    amount: 1200,
    paymentDate: '2024-05-01',
    status: 'متأخر',
    method: 'تقسيط',
    category: 'وارد',
  },
];

export default finance;
